import IconButton from '@mui/material/IconButton';
import ParticipationIcon from '@mui/icons-material/SupervisorAccount';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import AboutMeIcon from '@mui/icons-material/ContactMail';
import MediaIcon from '@mui/icons-material/PhotoLibrary';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Col, Row } from 'components/Grid';
import Page from 'containers/Page';
import PageMenu from 'containers/Page/Menu';
import PageMenuItem from 'containers/Page/MenuItem';
import useIsMobile from 'lib/useIsMobile';
import { useAuthContext } from 'AuthContext';

const styles = {
  iconButton: {
    padding: 0,
    width: null,
  },
  appbar: {
    backgroundColor: 'transparent',
  },
  header: {
    height: 34,
    marginTop: 10,
    marginBottom: 10,
    justifyContent: 'space-around',
  },
  badges: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  badgeItems: {
    marginTop: 5,
    marginBottom: 10,
    textAlign: 'center',
  },
};
const ProfilePage = ({ children, title }) => {
  const mobile = useIsMobile();
  const { showSignOutDialog } = useAuthContext();
  return (
    <Page
      links={[
        {
          icon: <AboutMeIcon />,
          label: 'About Me',
          path: '/profile',
          skip: !mobile,
        },
        {
          icon: <ParticipationIcon />,
          label: 'Participation',
          path: '/profile/participation',
        },
        {
          icon: <MediaIcon />,
          label: 'Feed',
          path: '/profile/feed',
        },
        {
          icon: <SettingsIcon />,
          label: 'Settings',
          path: '/profile/settings',
        },
      ]}
      rightButton={useMemo(
        () => (
          <IconButton
            onClick={showSignOutDialog}
            style={styles.iconButton}
            size='large'
          >
            <LogoutIcon color='#FFF' />
          </IconButton>
        ),
        [showSignOutDialog],
      )}
      title='Profile'
      titleLink='/profile'
      trackerTitle={`Profile > ${title}`}
    >
      <Row>
        <Col main>{children}</Col>
        <Col meta>
          {useMemo(
            () => (
              <PageMenu>
                <PageMenuItem
                  leftIcon={<LogoutIcon />}
                  onClick={showSignOutDialog}
                  primaryText='Sign Out'
                />
              </PageMenu>
            ),
            [showSignOutDialog],
          )}
        </Col>
      </Row>
    </Page>
  );
};

ProfilePage.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  viewer: PropTypes.node.isRequired,
};

export default ProfilePage;
